import { render } from "./ItemMenuPC.vue?vue&type=template&id=c143fc1a&scoped=true"
import script from "./ItemMenuPC.vue?vue&type=script&lang=js"
export * from "./ItemMenuPC.vue?vue&type=script&lang=js"

import "./ItemMenuPC.vue?vue&type=style&index=0&id=c143fc1a&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c143fc1a"]])

export default __exports__